import { FC } from 'react';
import { ToggleFollowButton } from '@/components/toggle-follow/toggle-follow-button.tsx';
import { EditProfileButton } from '@/routes/_app.$username/profile-card/main-statistics/identity/edit-profile/edit-profile-button.tsx';
import { ProfileActionsMenu } from '@/routes/_app.$username/profile-card/main-statistics/identity/profile-actions-menu.tsx';
import { useIsMe } from '../../../use-is-me.ts';
import * as identityInfoStyles from './identity.css.ts';
import { actionsContainer } from './identity.css.ts';

interface IdentityProps {
  userId: string;
  name: string;
  username: string;
  following: boolean;
  subscribedToUserPosts: boolean;
  backgroundImageKey?: string;
  isHighlighted: boolean;
}

export const Identity: FC<IdentityProps> = ({
  name,
  username,
  following = false,
  userId,
  backgroundImageKey,
  subscribedToUserPosts,
  isHighlighted,
}) => {
  const isMe = useIsMe();

  return (
    <div className={identityInfoStyles.mainContainer}>
      <div className={identityInfoStyles.identityInfoContainer}>
        <span className={identityInfoStyles.name}>{name}</span>
        <span
          className={identityInfoStyles.username}
          data-testid={'profile-username'}
        >
          @{username}
        </span>
      </div>
      <div className={actionsContainer}>
        {isMe ? (
          <EditProfileButton backgroundImageKey={backgroundImageKey} />
        ) : (
          <>
            <ToggleFollowButton
              userId={userId}
              following={following}
              variant={following ? 'secondary' : 'outline'}
              size="small"
            />
            <ProfileActionsMenu
              username={username}
              subscribedToUserPosts={subscribedToUserPosts}
              userId={userId}
              following={following}
              isHighlighted={isHighlighted ?? false}
            />
          </>
        )}
      </div>
    </div>
  );
};
